package uz.ferro.erp.feature.task.data

import js.objects.jso
import uz.ferro.erp.feature.excel.ExcelExportUtils
import uz.ferro.erp.feature.task.model.dto.TaskDto
import uz.ferro.erp.util.displayText
import uz.ferro.erp.util.formatDMY
import web.blob.Blob

object ExportTasksToExcelCase {

    suspend fun exportToExcel(tasks: List<TaskDto>): Blob {
        val excel = ExcelExportUtils.exportToExcel(
            sheetName = "Sheet 1",
            head = listOf(
                "ID",
                "Turi",
                "Sana",
                "Mijoz",
                "Bajaruvchi",
                "Tavsif",
                "Hujjat",
                "Hujjat Raqami",
                "Natija",
                "Izoh"
            ),

            content = tasks.map { task ->
                listOf(
                    task.id?.toString().orEmpty(),
                    task.typeName,
                    task.date.formatDMY(),
                    task.customer?.id.orEmpty(),
                    task.assignedTo?.name.toString(),
                    task.description.orEmpty(),
                    task.targetType.displayText(),
                    task.targetDocNum?.toString().orEmpty(),
                    task.resultTypeName.orEmpty(),
                    task.resultComment.orEmpty()
                )
            }
        )
        console.log(tasks)

        val blob = Blob(arrayOf(excel), jso {
            type = "text/xml"
        })
        return blob
    }
}